import {TreeViewBaseItem} from '@mui/x-tree-view';
import {CustomMenuItem} from '../common/arr-menu/ArrMenu';
import {ExtendedTreeItemProps} from '../../shared/interfaces';
import {ITagsList} from '../../api/types/tagFoldering.type';

export const ACTION_MENU: CustomMenuItem[] = [
  {
    id: 'new',
    label: 'New',
    disabled: true,
  },
  {
    id: 'edit',
    label: 'Edit',
    disabled: true,
  },
  {
    id: 'delete',
    label: 'Delete',
    disabled: true,
  },
];

export const findNodeById = (
  nodes: TreeViewBaseItem<ExtendedTreeItemProps>[],
  id: string
): TreeViewBaseItem<ExtendedTreeItemProps> | null => {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findNodeById(node.children, id);
      if (found) return found;
    }
  }
  return null;
};

export const buildTree = (items: ITagsList[] = []) => {
  const nodeMap: any = {};
  items.forEach((it: ITagsList) => {
    nodeMap[it.id] = {
      ...it,
      label: it.text,
      fileType: it.type === 'tags' ? 'tag_group' : '',
      skipParent: it.parent === '-1',
    };
    delete nodeMap[it.id].children;
  });

  const roots: TreeViewBaseItem<ExtendedTreeItemProps>[] = [];
  items.forEach((it: ITagsList) => {
    const node = nodeMap[it.id];
    const parentId = it.parent;
    if (!parentId || !nodeMap[parentId]) roots.push(node);
    else {
      const parent = nodeMap[parentId];
      if (!parent.children) parent.children = [];
      parent.children.push(node);
    }
  });

  Object.values(nodeMap).forEach((n: any) => {
    n.hasChildren = Array.isArray(n.children) && n.children.length > 0;
  });

  return roots;
};
